import { Switch } from 'antd'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Facebook, Instagram, Linkedin, Picture, RocketIcon, TikTok, XTwitter } from '../../assets/svgs/icons'
import styles from './styles.module.css'
export const SocialMediasSelector = ({onClickSocialMedia, selectedValues, headerText, onCheck, tutorialButtonComponent}) =>{

  const [isSwitchChecked, setIsSwitchChecked] = useState(false)

  useEffect(() => {
    onCheck(isSwitchChecked)
  }, [isSwitchChecked])
  
  return(
    <div id='social-medias-selector' className={styles.card}>
      <div className={styles.showPath}>
        <Picture color={'#AAAAAA'} width={20} height={20} />
        <p className={styles.patchTitle}>
          {headerText}
        </p>
        { tutorialButtonComponent && (
          <>
            {
              tutorialButtonComponent
            }
          </>
        )}
      </div>

      <div className={styles.iconsField}>
        <div
          className={styles.clickable}
          onClick={() => onClickSocialMedia(5)}
        >
          <Facebook
            color={selectedValues[5] ? '#6A0098' : '#AAAAAA'}
            width={24}
            height={24}
          />
        </div>

        <div
          className={styles.clickable}
          onClick={() => onClickSocialMedia(1)}
        >
          <Linkedin
            color={selectedValues[1] ? '#6A0098' : '#AAAAAA'}
            width={24}
            height={24}
          />
        </div>

        <div
          className={styles.clickable}
          onClick={() => onClickSocialMedia(4)}
        >
          <Instagram
            color={selectedValues[4] ? '#6A0098' : '#AAAAAA'}
            width={24}
            height={24} 
          />
        </div>

        <div
          id='social-medias-selector-item'
          style={{
            width: 24,
            marginLeft: -2,
          }}
          className={styles.clickable}
          onClick={() => onClickSocialMedia(3)}
        >
          <TikTok
            color={selectedValues[3] ? '#6A0098' : '#AAAAAA'}
            width={24}
            height={24}
          />
        </div>

        <div
          style={{
            width: 24,
            marginLeft: -2,
          }}
          className={styles.clickable}
          onClick={() => onClickSocialMedia(2)}
        >
          <XTwitter
            color={selectedValues[2] ? '#6A0098' : '#AAAAAA'}
            width={24}
            height={24}
          />
        </div>

      </div>
      <div
        style={{
          marginTop: 30,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 10,
          padding: '0px 10px 0px 0px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
          }}
        >
          <RocketIcon color="#aaaaaa" size="20" />
          <span style={{ fontFamily: 'Poppins' }}>
                Publicar Imediatamente
          </span>
        </div>

        <Switch
          id='scheduling-switch-component'
          size="small"
          style={{
            outline:'none',
            backgroundColor: isSwitchChecked ? '#9F00E4' : '',
          }}
          checked={isSwitchChecked}
          onClick={()=>setIsSwitchChecked((prev)=>!prev)}
        />
      </div>
    </div>
  )
}

SocialMediasSelector.propTypes = {
  /**
   * função chamada ao clicar uma media social retornando um parametro referente ao numero do index da rede selecionada
   */
  onClickSocialMedia:PropTypes.func,
  /**
   * array que define os valores para identificar as redes selecionadas
   */
  selectedValues:PropTypes.array,
  /**
   * define o texto ao lado do icone de imagem
   */
  headerText:PropTypes.string,
  /**
   * função chamada ao ativar o switch retornando true ou false
   */
  onCheck:PropTypes.func,
  /**
   * renderiza componente para exibição do tutorial
   */
  tutorialButtonComponent: PropTypes.node,
 
}